import { createContext, type ReactElement } from 'react';

import { DataProvider } from '../DataProvider';
import type { GhaContextValue } from './types';

export const GhaContext = createContext<GhaContextValue>({} as GhaContextValue);

export function GhaDataProvider({
  children,
  load = true,
}: {
  children: ReactElement | ReactElement[];
  load: boolean;
}): ReactElement {
  return (
    <DataProvider url="data/trace.json" DataContext={GhaContext} load={load}>
      {children}
    </DataProvider>
  );
}
